"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _excluded = ["className", "style", "responsive", "children", "box"];
var AnchorPanel = function AnchorPanel(props) {
  var className = props.className,
    style = props.style,
    responsive = props.responsive,
    children = props.children,
    _props$box = props.box,
    box = _props$box === void 0 ? true : _props$box,
    extraProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('anchor-panel');
  var classes = (0, _classnames.default)(prefixCls, className, {
    responsive: responsive
  }, {
    'none-box': !box
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes,
    style: style
  }, extraProps), children);
};
var _default = AnchorPanel;
exports.default = _default;